var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio3d"},[_c('switchCom-component',{staticClass:"switchPos"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }